import axios from "@/axios.js";
import SDSubStatus from "./sd_sub_status_service";

export default {
  getAllSDSubStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      SDSubStatus.getAllSDSubStatus(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchSDSubStatus(context, sd_sub_statusId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sd_sub_status/sd_sub_status/${sd_sub_statusId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
    fetchSDSubStatusByStatusIDAndRoleID(context, {status_id, role_id}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sd_sub_status/sd_sub_status/fetch_sd_sub_status_by_status_id_and_role_id/${status_id}/${role_id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAllSDSubStatus(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sd_sub_status/sd_sub_status/fetch_all_sd_sub_status`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeSDSubStatus(context, sd_sub_statusId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/sd_sub_status/sd_sub_status/${sd_sub_statusId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingSDSubStatusLists(context, sd_sub_status_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sd_sub_status/sd_sub_status/get_existing_sd_sub_status_lists/${sd_sub_status_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingSDSubStatusLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/sd_sub_status/sd_sub_status/search_existing_sd_sub_status_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateSDSubStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/sd_sub_status/sd_sub_status/update_sd_sub_status", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addSDSubStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/sd_sub_status/sd_sub_status/add_sd_sub_status", {
          item: item
        })
        .then(response => {
  
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeSDSubStatus({ commit }, sd_sub_statusId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/sd_sub_status/sd_sub_status/${sd_sub_statusId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
      fetchSDSubStatusByStatusIDForReview(context, {status_id, role_id , level}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sd_sub_status/sd_sub_status/fetch_sd_sub_status_by_status_id_and_role_id_for_review/${status_id}/${role_id}/${level}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
